(() => {
  if (!document.body.classList.contains('aur-focused-cart')) return;
  const activateTab = (tab) => {
    const root = tab.closest('[data-aur-cart-addons]');
    root.querySelectorAll('[data-aur-addon-tab]').forEach((button) => {
      const selected = button === tab;
      button.setAttribute('aria-selected', String(selected));
      button.tabIndex = selected ? 0 : -1;
    });
    root.querySelectorAll('[data-aur-addon-panel]').forEach((panel) => {
      panel.hidden = panel.dataset.aurAddonPanel !== tab.dataset.aurAddonTab;
    });
  };
  document.addEventListener('click', (event) => {
    const tab = event.target.closest('[data-aur-addon-tab]');
    if (tab) activateTab(tab);
    const model = event.target.closest('[data-aur-case-choice]');
    if (!model) return;
    const root = model.closest('[data-aur-cart-cases]');
    root.querySelectorAll('[data-aur-case-choice]').forEach((button) => button.setAttribute('aria-pressed', String(button === model)));
    root.querySelectorAll('[data-aur-case-form]').forEach((form) => { form.hidden = form.dataset.aurCaseForm !== model.dataset.aurCaseChoice; });
  });
  document.addEventListener('keydown', (event) => {
    const tab = event.target.closest('[data-aur-addon-tab]');
    if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    event.preventDefault();
    const tabs = Array.from(tab.closest('[role="tablist"]').querySelectorAll('[role="tab"]'));
    let index = tabs.indexOf(tab);
    if (event.key === 'Home') index = 0;
    else if (event.key === 'End') index = tabs.length - 1;
    else index = (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
    activateTab(tabs[index]);
    tabs[index].focus();
  });
  document.addEventListener('change', (event) => {
    const form = event.target.closest('[data-aur-case-form]');
    if (!form || event.target.name !== 'id') return;
    const option = event.target.selectedOptions[0];
    const root = form.closest('[data-aur-cart-cases]');
    const model = Array.from(root.querySelectorAll('[data-aur-case-choice]')).find((button) => button.dataset.aurCaseChoice === form.dataset.aurCaseForm);
    if (option.dataset.image) {
      model.querySelector('img').src = option.dataset.image;
      model.querySelector('img').alt = event.target.getAttribute('aria-label') + ' · ' + option.textContent;
    }
    const button = form.querySelector('[type="submit"]');
    button.disabled = !event.target.value;
    button.textContent = button.dataset.label + ' · ' + option.dataset.price;
    model.querySelector('b').textContent = option.dataset.price;
  });
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-aur-case-form]');
    if (!form) return;
    event.preventDefault();
    if (!form.reportValidity() || form.dataset.submitting === '1') return;
    form.dataset.submitting = '1';
    const button = form.querySelector('[type="submit"]');
    const error = form.querySelector('[role="alert"]');
    button.disabled = true;
    error.hidden = true;
    try {
      const response = await fetch(form.action + '.js', {method:'POST',body:new FormData(form),headers:{Accept:'application/json'}});
      const result = await response.json();
      if (!response.ok || result.status) throw new Error('Cart add failed');
      window.location.assign(form.querySelector('[name="return_to"]').value);
    } catch (err) {
      error.hidden = false;
      button.disabled = false;
      delete form.dataset.submitting;
    }
  });
})();
